import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { podeAcessarEmpresas } from '../../constants/usuarios-empresas-permitidos';

export const empresasGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (podeAcessarEmpresas(authService.userID)) {
    return true;
  }

  return router.createUrlTree(['/']);
};
